import React from "react";
import { Spin } from "antd";
 
const LoadableButton = ({
  lable,
  img,
  type = "button",
  isLoading = false,
  loadingLable = "Loading...",
  className = "",
  onClick,
  disabled = false,
}) => {
  return (
    <button
      type={type}
      disabled={disabled || isLoading}
      onClick={onClick}
      className={`btn-primary ${className} ${
        isLoading || disabled ? "opacity-70 cursor-not-allowed" : ""
      }`}
    >
      {isLoading ? (
        <div className="ant-white-spin space-x-4">
          <Spin />
          <span>{loadingLable}</span>
        </div>
      ) : (
        <>
          <span className={`${img ? "me-2" : ""}`}>{lable}</span>
 
          {img && (
            <img
              src="/assets/icons/ArrowRight.svg"
              alt="Icon"
              className="inline-block"
            />
          )}
        </>
      )}
    </button>
  );
};
 
export default LoadableButton;
